.replacement-image {
  border-radius: 0.6rem;
  font-family: Inter, sans-serif;
  font-size: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white-default);
  background-color: var(--deprecated-grey-white);
  box-sizing: border-box;
  height: 100%;
  width: 100%;

  p {
    text-transform: uppercase;
    font-weight: 600;
  }
}
